import { useId, useRef } from 'react';
import S from './InputStyles';

type Props = {
  label?: string;
  tooltip?: string;
  name: string;
  placeholder?: string;
  onChange: any;
  onBlur?: any;
  onFocus?: any;
  onKeyDown?: any,
  value?: string;
  defaultValue?: string | null;
  error?: string | boolean;
  styleWrapper?: Record<string, string>;
  type?: string;
  maxLength?: number;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  accept?: string;
  ref?: any;
};

function Input({
  label,
  tooltip,
  name,
  placeholder,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  value,
  defaultValue,
  error,
  styleWrapper,
  type = 'text',
  maxLength,
  min,
  max,
  step,
  disabled,
  accept,
  ref,
}: Props): JSX.Element {
  const id = useId();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === ',') {
      e.preventDefault();
      const input = inputRef.current;
      if (!input) return;
      const { selectionStart, selectionEnd } = input;
      const newValue = `${input.value.slice(0, selectionStart ?? undefined)}.${input.value.slice(selectionEnd ?? undefined)}`;
      onChange?.({ target: { name: input.name, value: newValue } });
    } else {
      onKeyDown?.(e);
    }
  };
  const valueIsChanged = ():boolean => defaultValue !== undefined && value !== undefined && value !== defaultValue;
  const stringTypes = ['date', 'email', 'number', 'password', 'tel', 'text', 'time', 'url'];
  return (
    <S.Wrapper
      error={!!error}
      style={styleWrapper}
      className={valueIsChanged() && stringTypes.includes(type) ? 'changed-value' : 'default-value'}
    >
      {!!label && (
        <label htmlFor={id}> {label} </label>
      )}
      <input
        id={id}
        ref={(el) => {
          (inputRef as any).current = el;
          if (typeof ref === 'function') ref(el);
          else if (ref) ref.current = el;
        }}
        name={name}
        placeholder={placeholder || label}
        title={tooltip}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={handleKeyDown}
        value={value}
        type={type}
        maxLength={maxLength}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        autoComplete="off"
        accept={accept}
      />
      {!!error && (
        <S.ErrorMessage> {error} </S.ErrorMessage>
      )}
    </S.Wrapper>
  );
}

export default Input;
